import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';

import Device from '../../components/admin/serviceconfig/device/Device';
import Route from '../../components/admin/serviceconfig/route/Route';
import Country from '../../components/admin/serviceconfig/country/Country';
import { BreadcrumbProvider } from '../../components/admin/serviceconfig/country/BreadcrumbContext';
import ErrorMessages from '../../components/admin/serviceconfig/errormessages/ErrorMessages';
import Layout from '../../components/layouts/Layout';

// ROUTES
import { AdminRoutes } from '../../routes/AdminRoutes';

const ServiceConfig = (props) => {
  const { accessLevel, accessType, navigate } = props;
  const { tab } = useParams();

  const generateTabs = () => (
    <>
      <Box sx={{ borderBottom: 2, borderColor: 'divider' }}>
        <Tabs
          value={tab || 'device'}
          onChange={(_event, newValue) => {
            navigate(`/admin/service-config/${newValue}`);
          }}
          aria-label="service config tabs"
        >
          <Tab label="Device" value="device" sx={{ paddingTop: 0.5 }} />
          <Tab label="Route" value="route" sx={{ paddingTop: 0.5 }} />
          <Tab label="Country" value="country" sx={{ paddingTop: 0.5 }} />
          <Tab
            label="Error Messages"
            value="errorMessages"
            sx={{ paddingTop: 0.5 }}
          />
        </Tabs>
      </Box>

      <Box sx={{ padding: 2, paddingTop: tab === 'country' ? 0 : 2 }}>
        {(!tab || tab === 'device') && <Device {...props} />}
        {tab === 'route' && <Route {...props} />}
        {tab === 'country' && (
          <BreadcrumbProvider>
            <Country {...props} />
          </BreadcrumbProvider>
        )}
        {tab === 'errorMessages' && <ErrorMessages {...props} />}
      </Box>
    </>
  );

  if (accessLevel === '3' && accessType === '3') {
    return (
      <Layout
        routes={AdminRoutes}
        title="Service Config"
        accessLevel={accessLevel}
        accessType={accessType}
      >
        {generateTabs()}
      </Layout>
    );
  }

  return null; // or some fallback UI if needed
};

export default ServiceConfig;
